import React, { Fragment } from "react";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import moment from "moment";
import { view } from "@risingstack/react-easy-state";

import { auth, bookings } from "../../stores/BaseStore";
import LoaderAbsolute from "../shared/LoaderAbsolute";

const StyledDialog = styled(Dialog)`
  .MuiBackdrop-root {
    background: #161e20;
    mix-blend-mode: normal;
    opacity: 0.5 !important;
  }

  .MuiPaper-root {
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
    overflow: visible;
  }

  .StripeElement {
    padding: 20px 16px 20px 16px;
    background-color: transparent !important;
    border: 0 !important;
    border-bottom: 1px solid #ffffff !important;
    border-radius: 0;

    outline: none !important;
    margin-bottom: 33px;

    &:focus {
      border: 0;
      border-bottom: 1px solid #0091d4;
      box-shadow: none !important;
    }

    &:hover {
      border-color: #0091d4;
    }
  }
`;

const StyledOuterWrapper = styled(Box)`
  position: relative;
  background: #273032;
  width: 100%;
  z-index: 3;

  h3 {
    margin: 0;
    line-height: 80px;

    span {
      color: #0091d4;
    }
  }

  @media (max-width: 1279px) {
    overflow-y: scroll;
  }
`;

const StyledInnerWrapper = styled(Box)`
  position: relative;
  z-index: 3;
  margin-bottom: 2rem;
`;

const StyledButtonPrimary = styled.button`
  width: 100%;
  color: #ffffff;
  font-size: 16px;
  background-color: #0091d4;
  border: 1px solid #0091d4;
  border-radius: 0;
  padding: 20px;
  cursor: pointer;
  letter-spacing: 1.42857px;
  margin-top: 2rem;

  &:hover {
    opacity: 0.8;
  }

  width: 100%;
`;

const StyledSideWrapper = styled(Box)`
  position: absolute;
  top: 100px;
  left: -136px;
  background-color: #161e20;
  width: 324px;

  @media (max-width: 1279px) {
    position: relative;
    left: unset;
    margin-bottom: 72px;
    width: 100%;
  }
`;

const StyledSideWrapperInner = styled(Box)`
  padding: 32px 59px 32px 32px;
`;

const StyledSideWrapperTitle = styled.p`
  font-family: "Polaris", "Arial", sans-serif;
  font-size: 24px;
  line-height: 31px;
  letter-spacing: 0.176471px;
  color: #0091d4;
  margin: 0;
  margin-bottom: 5px;

  @media (max-width: 599px) {
    font-size: 16px;
  }
`;

const StyledCloseButton = styled.span`
  // position: fixed;
  // top: 60px;
  // right: 60px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 4;

  svg {
    font-size: 88px;
    color: #0091d4;

    &:hover {
      opacity: 0.8;
    }
  }

  // @media (max-width: 1279px) {
  //   position: relative;
  //   left: 20px;
  //   top: 100px;
  // }
`;

const StyledSideWrapperSubTitle = styled.p`
  font-family: "AzoSans Black", "Arial", sans-serif;
  font-size: 48px;
  line-height: 48px;
  letter-spacing: 0.352941px;
  margin: 0;
`;

const StyledTrainerName = styled.p`
  font-family: "AzoSans Bold", "Arial", sans-serif;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.75px;
  color: #0091d4;
  margin: 0;
  margin-bottom: 25px;
`;

const StyledTrainerDesc = styled.p`
  font-family: "AzoSans Regular", "Arial", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.4375px;
  color: #a7acb3;
  margin: 0;
`;

const StyledConfigurationName = styled.p`
  font-family: "AzoSans Bold", "Arial", sans-serif;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.75px;
  color: #a7acb3;
  margin: 0;
  margin-bottom: 25px;
`;

const StyledConfigurationDetails = styled.p`
  font-family: "AzoSans Bold", "Arial", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.4375px;
  color: #a7acb3;
  margin: 0;
`;

const StyledDateWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 113px;
  height: 88px;
  width: 88px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #0091d4;
`;

const StyledDateDay = styled.p`
  font-family: "Polaris", "Arial", sans-serif;
  font-size: 36px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 3.21429px;
  margin: 0;
  margin-bottom: 3px;
`;

const StyledDateMonth = styled.p`
  font-family: "Polaris", "Arial", sans-serif;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.128571px;
  letter-spacing: 0.0714286px;
  margin: 0;
`;

const StyledEventTime = styled.p`
  font-family: "Polaris", "Arial", sans-serif;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.128571px;
  color: #2690d7;
  margin: 0;
  margin-bottom: 65px;
  margin-top: 35px;

  span {
    color: #ffffff;
  }
`;

const StyledMessageWrapper = styled(Box)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  font-size: 16px;
  padding: 24px;
  text-align: center;
`;

const CancelPayment = view((props) => {
  const { cancelPaymentDialogue, setCancelPaymentDialogue, event } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const date = moment(event.starts_at).format("D");
  const month = moment(event.starts_at).format("MMM");
  const day = moment(event.starts_at).format("dddd");
  const time = moment(event.starts_at).format("h A");
  const year = moment(event.starts_at).format("YYYY");

  const handleClose = () => {
    setCancelPaymentDialogue(false);
    if (bookings.cancelMessage) {
      bookings.singleBooking = null;
      setTimeout(() => {
        bookings.getUserBooking(event.id);
      }, 3000);
    }
    bookings.cancelMessage = null;
  };

  const handleSubmit = async (e) => {
    // Block native form submission.
    e.preventDefault();

    await bookings.cancelUserBooking(event.id, bookings.singleBooking[0].id);
  };

  return auth.user ? (
    <StyledDialog
      fullWidth={true}
      maxWidth={"md"}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={cancelPaymentDialogue}
      disableScrollLock={true}
    >
      <StyledOuterWrapper px={matches ? 12 : 6} pb={"307px"}>
        {!bookings.isLoading ? (
          <StyledCloseButton onClick={handleClose}>
            <CloseIcon />
          </StyledCloseButton>
        ) : null}
        {bookings.isLoading ? (
          <LoaderAbsolute />
        ) : bookings.cancelMessage ? (
          <StyledMessageWrapper>{bookings.cancelMessage}</StyledMessageWrapper>
        ) : (
          <Fragment>
            <StyledDateWrapper>
              <StyledDateDay>{date}</StyledDateDay>
              <StyledDateMonth>{month}</StyledDateMonth>
            </StyledDateWrapper>
            <StyledSideWrapper>
              <StyledSideWrapperInner>
                <StyledSideWrapperTitle>seats left</StyledSideWrapperTitle>
                <StyledSideWrapperSubTitle>
                  {event.available_slots ? event.available_slots : "-"}
                </StyledSideWrapperSubTitle>
              </StyledSideWrapperInner>
              <StyledSideWrapperInner>
                <StyledSideWrapperTitle>price</StyledSideWrapperTitle>
                <StyledSideWrapperSubTitle>
                  {event.price ? event.price : 0} €
                </StyledSideWrapperSubTitle>
              </StyledSideWrapperInner>
              <StyledSideWrapperInner>
                <StyledSideWrapperTitle>trainer</StyledSideWrapperTitle>
                <StyledTrainerName>
                  {event.trainer_title ? event.trainer_title : "-"}{" "}
                </StyledTrainerName>
                {event.trainer_description ? (
                  <StyledTrainerDesc>
                    {event.trainer_description}
                  </StyledTrainerDesc>
                ) : null}
              </StyledSideWrapperInner>
              <StyledSideWrapperInner>
                <StyledSideWrapperTitle>configuration</StyledSideWrapperTitle>
                <StyledConfigurationName>
                  {event.Venue.configuration ? event.Venue.configuration : "-"}{" "}
                </StyledConfigurationName>
                {event.Venue.computer_configuration ? (
                  <StyledConfigurationDetails>
                    {event.Venue.computer_configuration}
                  </StyledConfigurationDetails>
                ) : null}
              </StyledSideWrapperInner>
            </StyledSideWrapper>
            <Grid container justify="center">
              <Grid item xs={12} md={6} mx="auto">
                <Box>
                  <StyledEventTime>
                    {day} <span>{time}</span> {year}
                  </StyledEventTime>
                </Box>
                <StyledInnerWrapper>
                  <h3>
                    Booking and <span>Payment</span>
                  </h3>
                </StyledInnerWrapper>
                <StyledInnerWrapper>
                  <form onSubmit={handleSubmit}>
                    <StyledButtonPrimary type="primary" htmlType="submit">
                      cancel booking
                    </StyledButtonPrimary>
                  </form>
                </StyledInnerWrapper>
              </Grid>
            </Grid>
          </Fragment>
        )}
      </StyledOuterWrapper>
    </StyledDialog>
  ) : null;
});

export default CancelPayment;
